import { useNavigateWithHistory } from '../useNavigateWithHistory';
import { useLocationWithState } from '../useLocationWithState';
import { useProfilesLocalStorage } from '../../ProfilesLocalStorageContext';
import { LOGIN_ONBOARDING_PATH } from '../routeNames';

export default function useGoBackOrGoHome() {
  const navigate = useNavigateWithHistory();
  const { state: reactRouterState } = useLocationWithState();

  const isFirstUser = !useProfilesLocalStorage().profiles.length;
  const fallbackUrl = isFirstUser ? `/${LOGIN_ONBOARDING_PATH}` : '/';

  return () => {
    if (reactRouterState?.from) {
      navigate(-1);
    } else {
      navigate(fallbackUrl, {
        replace: true,
      });
    }
  };
}
